module.exports = {
    Confirm:"အတည်ပြုသည်",
    pleaseWait:"ကျေးဇူးပြု၍ ခနစောင့်ပါ",
    loading:"လုပ်ဆောင်နေသည်",
    ID:"အိုင်ဒီ",
    FAQ:"မေးလေ့ရှိသော မေးခွန်းများ",
    TC:"စည်းကမ်းနှင့်သတ်မှတ်ချက်များ",
    Submit:"ဟုတ်ပြီ",
    change:"‌ပြောင်းရန် ",
    English:"အင်္ဂလိပ်",
    Myanmar:"မြန်မာ",
    Login:"အကောင့်ဝင်မည်",
    Logout:"အကောင့်မှထွက်မည်",
    register:"စာရင်းသွင်းမည်",
    OK:"အိုကေ",
    getCode:"ကုဒ်ပြန်တောင်းမည်",
    Continue:"ဆက်လက်လုပ်ဆောင်မည်",
    language0:"ဘာသာစကား",
    language:"ဘာသာစကားရွေးပါ",
    Copyright:"© ၂၀၂၅ မူပိုင်ခွင့်အားလုံးရှိသည်။",
    Daily:"နေ့စဉ်",
    Weekly:"အပတ်စဉ်",
    ChancesLeft:"ကျွန်ုပ်၏ပွိုင့်",
    BuyChances:"အကြိမ်ရေဝယ်ရန်",
    BuyChancesC:"သင်အကြိမ်ရေ ထပ်မံဝယ်ယူတော့မည်",
    ConfirmPurchase:"ဝယ်ယူမှုအတည်ပြုပါ",
    languageTips:"ဘာသာစကားကို ဤနေရာတွင်ရွေးချယ်ပါ",
    loginTips:"ဖုန်းနံပါတ်ထည့်ပါ",
    profile:"ကိုယ်ရေးအချက်အလက်",
    phoneNumber:"ဖုန်းနံပါတ်",
    select:"ရွေးချယ်ပါ",
    Monthly:"လစဉ်",
    PhoneNo:"ဖုန်းနံပါတ်",
    Level:"အဆင့်",
    Rank:"အဆင့်များ",
    RedeemCenter:"ဆုလဲလှယ်ရန်",
    redeemTips1:"ရရှိနိုင်သောဆုများကြည့်ရှုရန်",
    Categories:"အမျိုးအစားများ",
    ChooseHere:"ဤနေရာတွင်ရွေးပါ",
    game1T:"AI လေ့ကျင့်မှု",
    game2T:"အဆင့်သတ်မှတ်ရန်",
    game2T2:"အဆင့်ဖြင့်ကစားရန်",
    game3T:"အဖွဲ့လိုက်ပြိုင်ရန်",
    game4T:"အဆုံးမဲ့စိန်ခေါ်ရန်",
    game1C:"သင်၏အသိပညာတိုးတက်စေမည့် ဉာဏ်ရည်မေးခွန်းဖျော်ဖြေရန်ပါတနာ!",
    game2C:"အချိန်နှင့်တပြေးညီ ပြိုင်ဘက်များနှင့် တိုက်ရိုက်ပြိုင်ဆိုင်ပါ!",
    game3C:"မိတ်ဆွေများနှင့်အတူ သင်၏အသိပညာကို စစ်ဆေးပါ!",
    Ranking:"အဆင့်များ",
    rankList:"အဆင့်စာရင်း",
    RedeemList:"ရရှိနိုင်မည့်ဆုများ",
    Settings:"ဆက်တင်များ",
    ChooseTitle:"သင်ကြိုက်နှစ်သက်ရာ ရွေးပါ",
    Save:"သိမ်းမည်",
    Back:"နောက်သို့",
    game1Tips1:"ခက်ခဲသောအဆင့်ကို ရွေးချယ်ပါ",
    Easy:"လွယ်ကူသော",
    Medium:"အလယ်အလတ်",
    Hard:"ခက်ခဲသော",
    Matchmaking:"ကိုက်ညီမှုရှာဖွေခြင်း",
    BackToHome:"ပင်မစာမျက်နှာသို့",
    PlayAgain:"ကစားမည် !",
    WaitingTips:"မိတ်ဆွေများဝင်ရောက်လာရန် စောင့်နေသည်",
    Draw:"တူညီသောအမှတ် - ညီမျှ",
    GameOver:"ဂိမ်းပြီးသွားပြီ",
    CreateRoom:"ကစားခန်းဖန်တီးပါ",
    JoinRoom:"ကစားခန်းသို့ဝင်ပါ",
    RoomID:"ကစားခန်းနံပါတ်",
    enterRoomID:"ကစားခန်းနံပါတ်ထည့်ပါ",
    MatchingLevel:"ကိုက်ညီမှုအဆင့်",
    Waiting:"စောင့်နေသည်",
    Congratulations:"ဂုဏ်ယူပါတယ်၊ သင်အနိုင်ရခဲ့သည်",
    SorryLost:"စိတ်မကောင်းပါ၊ သင်ရှုံးခဲ့သည်",
    YourScore:"သင့်အမှတ်",
    OpponentScore:"ပြိုင်ဘက်အမှတ်",
    StartNow:"ယခုစမည်!",
    subscribe:'စာရင်းသွင်းမည်',
    Later:'နောက်မှ',
    BuyMore:'ဝယ်ယူမည်',
    Points:'ပွိုင့်များ',
    Chances:'အကြိမ်ရေ',
    ChanceEnough:'သင်၏လက်ကျန်အကြိမ်ရေမလုံလောက်ပါ ',
    currentLevel:'လက်ရှိအဆင့်',
    YouCanRedeem:'သင့်ရဲ့ လဲလှယ်ခွင့်',
    moreTimes:'အကြိမ်ရေ',
    Redeem:'လဲမည်',
    congratulations:'ဂုဏ်ယူပါတယ်',
    redeemTips:'သင်ဆုလဲလှယ်ပါမည်',
    Challenge:'စိန်ခေါ်ခြင်း',
    RankingChallenge:'အမှတ်ဖြင့် စိန်ခေါ်ခြင်း',
    FriendChallenge:'သူငယ်ချင်းနှင့် စိန်ခေါ်ခြင်း',
    FastChallenge:'လျင်မြန်မှု စိန်ခေါ်ခြင်း',
    nickname:'နာမည်',
    PickLevel:'အဆင့်ရွေးပါ',
    PiggyBank:'ဝက်စုဘူး',
    PiggyBankTips1:'သင့်ဝက်စုဘူး ပြည့်နေပြီ!',
    PiggyBankTips12:'သင့်ဝက်စုဘူး မပြည့်သေးပါ',
    CollectNOW:'အခု ထုတ်ယူပါ',
    PiggyBankTips2:'ဝက်စုဘူးလေးက ၃၀မိနစ်တစ်ခါတောက်ပတဲ့ ကွိုင်၅၀ကို သင့်အတွက်ပေးနေပါတယ်၊ ကွိုင်လေးတွေကို မဆုံးရှုံးပါစေနဲ့ အခုပဲယူပြီး သင့်ရဲ့လက်ကျန်ကိုတိုးမြှင့်လိုက်ပါ',
    invitation:'ဖိတ်ခေါ်ပြီး ဆုတွေရယူပါ',
    invitationTips:'ဖိတ်ခေါ်လင့်ခ်ကို ကူးယူပါ၊ သူငယ်ချင်းကို ဝင်ရောက်ေဆာ့ကစားခိုင်းပြီး ကွိုင် ၁၀၀၀ ရယူပါ!',
    InviteFriends:'သူငယ်ချင်း ဖိတ်ခေါ်ခြင်း',
    copy:'ကူးယူပါ',
    DaysLogin:'၇ရက် လော့ဂ်အင် ဝင်ခြင်း',
    SpinWheel:'ကံတရားလှည့်ဘီး',
    books:'စာအုပ်များ',
    Cancel:'ပယ်ဖျက်သည်',
    Upgrade:'အဆင့်မြှင့်',
    bookTips1:'စာအုပ်ကို အဆင်မြှင့်သည်',
    Costs:'ကျသင့်သည်',
    bookTips2:'အဆင့်မြှင့်၍မရပါ၊ ဗဟုသုတစာအုပ် သို  ပွိုင့်မလုံလောက်ပါ။',
    BackgroundMusic:'နောက်ခံသီချင်း',
    spin:'လှည့်ခြင်း',
    luckySpin:'ကံစမ်းလှည့်ခြင်း',
    spinTips1:'သင်ကံထူးပါသည်',
    tks:'ကျေးဇူးတင်ပါသည်',
    spinTips2:'နေ့စဥ် အခမဲ့လှည့်ခွင့်',
    spinTips3:'အခမဲ့လှည့်ခွင့်တိုကင်ကိုရယူပြီး ဒီနေ့ သင့်ရဲ့ကံကိုစမ်းကြည့်ပါ',
    spinTips4:'တိုကင်ရယူပါ',
    SpinChances:'လှည့်ခွင့်များ',
    date:'နေ့စွဲ',
    Prizes:'ဆုများ',
    nochance:'သင့်မှာအခွင့်အရေး မလုံလောက်ပါ',
    WinnerList:'ကံထူးသူစာရင်း',
    Purchasefailed:'ဝယ်ယူခြင်းမအောင်မြင်ပါ',
    start:'စတင်သည်',
    No:'နိုး',
    Title:'ခေါင်းစဥ်',
    RequireLevel:'လိုအပ်သောအဆင့်',
    Bouns:'ဘောနပ်စ်',
    YourRoomCode:'သင့်အခန်းကုဒ်',
    Shop:'ဆိုင်',
    shop:'ဆိုင်',
    bank:'ဘဏ်',
    home:'အိမ်',
    enterRoomCode:'အခန်းကုဒ် ထည့်ပါ',
    getChance:'ကံစမ်းလှည့်ခွင့် ရယူပါ',
    landTips1:'သင့်ရဲ့ကံကောင်းခြင်းတွေက စောင့်ကြိုနေပါတယ်',
    landTips2:'ပျော်ရွှင်စရာ မေးခွန်းလေးတွေ ‌ဖြေဆိုရင်း ကွိုင်လေးတွေစုပြီး Fortune Wheel ကြီးကို လှည့်လိုက်ကြစို့။ တစ်ခါလှည့်တိုင်းမှာ စိတ်လှုပ်ရှားစရာ ဆုလက်ဆောင်တွေ ကံထူးနိုင်ပါပြီနော်။',
    reture:'ပြန်သွားပါ',
    question_ready:'မေးခွန်းများကိုပြင်ဆင်နေသည်',
    question:'မေးခွန်း',
    Correct:'မှန်ကန်သည်',
    Category:'အမျိုးအစား',
    Claim:'ရယူပြီး',
  Game_Time:'ဂိမ်းအချိန်',
  Game_Bonus:'ဂိမ်းအပိုဆု',
  Game_Free:'အခမဲ့ဂိမ်း',
  Rewards: "ဆုများ ",
  EntryFee: "ဝင်ကြေး",
  Spins: "လှည့်ခွင့်များ",
  book_rule:'စာအုပ် အဆင့်မြှင့်တင်ခြင်း စည်းမျဉ်း',
  Book_in_Need:'လိုအပ်သောစာအုပ်',
  Coin_in_Need:'လိုအပ်သောကွိုင်',
  Coin_Bonus:'အပိုကွိုင်',
  daily_challenge:'နေ့စဥ်စိန်ခေါ်မှု : ',
  share_challenge:'မျှဝေသောစိန်ခေါ်မှု : ',
}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js